import SignupModal from './SignupModal.vue'
import events from './events'

const install = function (Vue, params = {}) {
    if (this.installed) {
        return
    }

    this.installed = true
    this.params = params

    Vue.component('signupModal', SignupModal)
    Vue.prototype.$signupModal = {
        open: function () {
            events.$emit('open')
        },
        thanks: function () {
            events.$emit('thanks')
        }
    }
    Vue.$signupModal = Vue.prototype.$signupModal
}
var plugin = {install}

export default plugin



// WEBPACK FOOTER //
// ./apps/comps/SignupModal/plugin.js